// eslint-disable-next-line import/prefer-default-export
export const BASE_EN = {
  // Filters
  OthersFilters: 'Other filters',
  AvailableFilters: 'Available filters',
  KeyWords: 'Name:',
  placeholderNameApplicant: "Applicant's name",
  placeholderNameVacancy: 'By vacancy:',
  Search: 'Search',
  AddFilter: 'Add filters',
  optionFilter: 'Others functions',
  Basics: 'Basics',
  ByStars: 'By stars:',
  Stars: 'Stars',
  ApplicantsState: "Applicant's status:",
  ByDate: 'By date:',
  OrderBy: 'Order by:',
  Newer: 'Newer',
  Older: 'Older',
  Institutes: 'Institutes',
  OnlySavedApplicants: 'Saved',
  clear: 'Clear',
  apply: 'Apply',

  // data
  Results: 'Results',
  VacancyName: 'Vacancy name',
  Score: 'Score',
  Status: 'Status',
  Date: 'Date',
  NoData: 'No data was found',
  NoDataNoJob: 'In this section you can find all candidates who apply to your open positions.',
  All: 'All',
  Pending: 'Pending',
  InProcess: 'In process',
  Accepted: 'Accepted',
  Rejected: 'Rejected',
  Selected: 'Selected',
  AddToVacancy: 'Add to vacancy',
  SendEmail: 'Send email',

  // modalAddCandidate
  AddCandidate: 'Add candidate',
  exportPDF: 'Export to PDF',
  exportExcel: 'Export to Excel',
  ExportCandidates: 'Export candidates',
  ImportCandidates: 'Import candidates',
  NewCandidate: 'New candidate',
  placeholderFirstName: 'First name',
  placeholderLastName: 'Last name',
  placeholderEmail: 'Email',
  placeholderPhone: 'Phone',
  SelectCv: 'Select cv (Optional)',
  GeneratedId1: 'We have generated the ID: ',
  GeneratedId2: ' for your file',
  placeholderTextArea: 'Type something about the candidate',
  reloadPage: 'Reload page to see this candidate',
  Add: 'Add',
  AddPhoneSecondary: 'Add secondary number',
  AddEmailSecondary: 'Add secondary email',

  // modalImportCandidate
  Instructions: 'Instructions',
  placeholderSelectVacancy: 'Select a vacancy',
  ImportHeader: 'Import candidates',
  ImportExcell: 'Import from Excell',
  SelectVacancy: 'Select the vacancy to which the applicant will be added:',
  CandidateFirstName: 'First name:',
  CandidateLastName: 'Last name:',
  CandidateEmail: 'Email:',
  CandidatePhone: 'Phone:',
  Cv: 'CV:',
  Accept: 'Accept',

  // modalInvitation
  inviteHeader: 'Invite candidate',
  invitationMessage: 'Which invitation mail do you want to sent to ',
  template: 'Template',
  customize: 'Customize',

  // modalCustomInvitationEmail
  CustomInvitationHeader: 'Customize invitation mail',
  example: 'Example',
  textExample: 'Hello {Candidate}, how are you?',
  preview: 'Preview',
  textPreview: 'Hello Carlos Antonio Méndez, how are you?',
  importantInfo: 'Important info',
  company: 'Company',
  vacancy: 'Vacancy',
  candidate: 'Candidate',
  send: 'Send',
  placeholder: 'Type something',
  whichMail: 'Which mail do you want to send to the candidate?',
  customizeMail: 'Customize mail',

  // Instructions
  Instruction1: 'Upload an Excell file with the candidates info.',
  Instruction2: 'Choose the vacancy to which the info will be loaded.',
  Instruction3:
    'If you leave this field empty the data will be uploaded but it will be visible only in Candidates database.',
  Instruction4: 'Choose the headlines in your Excel file that contain the required info for each field.',
  Instruction5: 'If you leave this field empty, the candidates will be saved without it.',

  // Candidate details
  ApplicantDetails: 'Applicant details',
  AddedBy: 'Added by ',
  On: 'on ',

  // Table
  candidateName: 'Candidate name',
  vacancyName: 'Vacancy name',
  score: 'Score',
  status: 'Status',
  date: 'Date',
  actions: 'Options',
  select: 'Select',
  lastNames: 'Last names',
  addBaseCandidates: 'Agregado desde Base de candidatos',

  // Asignar
  titleAsignar: 'In which vacancies do we register candidates?',
  cancel: 'Cancel',
  transfer: 'Transfer',
  invite: 'Invite',
  register: 'Registering...',
  // Export Titles
  numberEmpty: 'No phone number',
  Average: 'Average',
  emailEmpty: 'No email',
  AverageEmpty: 'It does not have a questionnaire',
  cvEmpty: 'Without cv',
  Unrated: 'Unrated',
  FirstName: 'First Name',
  LastName: 'Last Name',
  Email: 'Email',
  EmailSecondary: 'Email Secondary',
  Qualification: 'Qualification',
  PhoneNumber: 'Phone number',
  SecondaryNumber: 'Secondary Number',
  Description: 'Description',
  DescriptionEmpty: 'Without description',
  cvWithBias: 'Cv with bias',
  cvWithoutBias: 'Cv without bias',
  Comments: 'Comments',
  CommentsEmpty: 'No comment',
};
